import React from "react";

function Icon(props) {
    let iconName = props.iconName;

    let iconClasses = ["micon"];
    if (props.small) {
        iconClasses.push("small");
    } else if (props.large) {
        iconClasses.push("large");
    }

    if (props.light) {
        iconClasses.push("light");
    } else if (props.dark) {
        iconClasses.push("dark");
    }

    return iconName.length ? (
        <i style={props.style} className={iconClasses.join(" ")} onClick={props.onClick}>
            {iconName}
        </i>
    ) : null;
}

export default Icon;
